import { render, staticRenderFns } from "./global-background.vue?vue&type=template&id=4ea4401c&scoped=true&"
import script from "./global-background.vue?vue&type=script&lang=js&"
export * from "./global-background.vue?vue&type=script&lang=js&"
import style0 from "./global-background.vue?vue&type=style&index=0&id=4ea4401c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea4401c",
  null
  
)

export default component.exports